(function ($) {
    var $routes = $.cdh.routes;

    var httpRequestDefaults = {
        errorMessage: 'Loading Error.',
        responseConverter: function (data) {
            return data;
        },
        emptyValue: {},
        type: undefined,
        processData: true,
        cache: false
    };

    function httpRequest(url, options) {
        const self = this;

        if (typeof (url) == 'function')
            url = url();

        let o = $.extend(true, {}, httpRequestDefaults, options);
        let ajax = null;

        self.data = $.isArray(o.emptyValue) ? ko.observableArray(o.emptyValue) : ko.observable(o.emptyValue);
        self.rawData = $.isArray(o.emptyValue) ? ko.observableArray(o.emptyValue) : ko.observable(o.emptyValue);
        self.hasData = ko.observable(false);
        self.isLoading = ko.observable(false);
        self.error = ko.observable('');
        self.requestCanceled = ko.observable(false);

        self.state = ko.pureComputed(function () {
            return {
                data: self.data(),
                hasData: self.hasData(),
                isLoading: self.isLoading(),
                error: self.error()
            };
        });

        self.load = function (data, timeout) {
            if (self.isLoading())
                return;

            self.isLoading(true);
            self.hasData(false);
            self.data(o.emptyValue);
            self.rawData(o.emptyValue);
            self.error('');
            self.requestCanceled(false);

            let finished = $.Deferred();

            let request = {
                url: url,
                type: o.type,
                headers: {},
                processData: o.processData,
                data: data,
                cache: o.cache,
                context: self
            };

            self.getSmrg(request);

            if (request.processData === false)
                request.contentType = false;

            if (o.contentType)
                request.contentType = o.contentType

            setTimeout(function () {
                ajax = $.ajax(request)
                    .done(function (rawJson, textStatus, xhr) {
                        self.checkUnauthorizedResponse(xhr);
                        try {
                            let values = o.responseConverter(rawJson);
                            self.setSmrg(xhr);
                            self.data(values);
                            self.rawData(rawJson);
                            self.hasData(true);
                            self.isLoading(false);

                            // if ($('div.mfp-wrap').length) {
                            //     $.cdh.helper.updateMagnificPopupBgHeight();
                            // }
                        } catch (err) {
                            self.error(o.errorMessage);
                            self.hasData(false);
                            console.error(err);
                        }
                        finished.resolve(rawJson);
                    })
                    .fail(function (e) {
                        let errorMessage = e.responseJSON && e.responseJSON.message ? e.responseJSON.message : o.errorMessage;
                        if (!e.getAllResponseHeaders()) {
                            self.requestCanceled(true);
                            errorMessage = 'Request Canceled.';
                        }

                        if (e.status === 503) {
                            $.cdh.global.maintenance(true);
                            errorMessage = $.cdh.customLabels.maintenanceErrorMessage;
                        }

                        self.error(errorMessage);

                        $(window).scrollTop(0);
                        console.error(e);
                        finished.reject(e);
                    })
                    .always(function () {
                        self.isLoading(false);
                    });
            }, timeout ? timeout : 0);

            return finished.promise();
        };

        self.setSmrg = function (xhr) {
            let smrg = xhr.getResponseHeader('smrg-nwcp')
            if (smrg) {
                if (smrg === 'remove') {
                    $.cdh.localStorage.setObject('smrg-nwcp', null);
                    return;
                }
                $.cdh.localStorage.setObject('smrg-nwcp', {date: new Date(), data: smrg});
            }
        }

        self.getSmrg = function (request) {
            let smrg = $.cdh.localStorage.getObject('smrg-nwcp');
            if (smrg) {                
                if ((new Date() - smrg.date / 1000) > 86400 || smrg.data === 'remove') {
                    $.cdh.localStorage.setObject('smrg-nwcp', null);
                    return;
                }                
                request.headers['smrg-nwcp'] = smrg.data;
            }
        }

        self.checkUnauthorizedResponse = function (xhr) {
            try {
                let header = xhr.getResponseHeader('X-Responded-JSON');
                if (header) {
                    let obj = JSON.parse(header);
                    if (obj.status == 401) {
                        window.location.href = obj.headers.location;
                    }
                }
            } catch (err) {
                console.error(err);
            }
        };

        self.loadIfNoData = function (data) {
            if (!self.hasData() && !self.isLoading()) {
                self.load(data);
            }
        };

        self.cancel = function () {
            if (ajax) {
                ajax.abort();
                self.requestCanceled(true);
            }
        };

        self.setData = function (data) {
            self.data(data);
            self.hasData(JSON.stringify(data) != JSON.stringify(o.emptyValue));
            self.isLoading(false);
            self.error('');
            self.requestCanceled(false);
        };
    }

    function httpGet(url, options) {
        var o = $.extend(true, {type: 'GET'}, options);
        httpRequest.call(this, url, o);
    }

    function httpDelete(url, options) {
        var o = $.extend(true, {type: 'DELETE'}, options);
        httpRequest.call(this, url, o);
    }

    function httpPost(url, options) {
        var o = $.extend(true, {type: 'POST'}, options);
        httpRequest.call(this, url, o);
    }

    function httpPut(url, options) {
        var o = $.extend(true, {type: 'PUT'}, options);
        httpRequest.call(this, url, o);
    }

    var getRequests = {
        bankAcount: {
            get: function (dataPartnerId, responseConverter) {
                httpGet.call(this,
                    $routes.bankAccounts.get(dataPartnerId),
                    {responseConverter: responseConverter, emptyValue: []});
            },
            getConfirmed: function (dataPartnerId, responseConverter) {
                httpGet.call(this,
                    $routes.bankAccounts.getConfirmed(dataPartnerId),
                    {responseConverter: responseConverter, emptyValue: []});
            }
        },
        contribution: {
            getValidDates: function (dataPartnerId) {
                httpGet.call(this,
                    $routes.contributions.getValidDates(dataPartnerId));
            },
            getPending: function (accountId, responseConverter) {
                httpGet.call(this,
                    $routes.contributions.pending(accountId),
                    {responseConverter: responseConverter, emptyValue: []});
            },
            getSummary: function (accountId, responseConverter) {
                httpGet.call(this,
                    $routes.contributions.summary(accountId),
                    {responseConverter: responseConverter, emptyValue: []});
            }
        },
        transaction: {
            get: function (responseConverter) {
                httpGet.call(this,
                    $routes.transactions.get(),
                    {responseConverter: responseConverter, emptyValue: []});
            },
            getPage: function (responseConverter) {
                httpGet.call(this,
                    $routes.transactions.getPage(),
                    {responseConverter: responseConverter, emptyValue: []});
            },
            recent: function (responseConverter) {
                httpGet.call(this,
                    $routes.transactions.recent(),
                    {responseConverter: responseConverter, emptyValue: []});
            },
            getYearsWithAccounts: function (responseConverter) {
                httpGet.call(this, $routes.transactions.getYearsWithAccounts(),
                    {responseConverter: responseConverter, emptyValue: []});
            },
            getReassociated: function (responseConverter) {
                httpGet.call(this,
                    $routes.transactions.getReassociated(),
                    {responseConverter: responseConverter, emptyValue: []});
            },
            details: function (transactionKey) {
                httpGet.call(this, $routes.transactions.details(transactionKey));
            },
            details60: function (transactionKey) {
                httpGet.call(this, $routes.transactions.details60(transactionKey));
            },
            detailsReassociated: function (transactionKey) {
                httpGet.call(this, $routes.transactions.detailsReassociated(transactionKey));
            }
        },
        alert: {
            get: function (responseConverter) {
                httpGet.call(this, $routes.alerts.get(),
                    {responseConverter: responseConverter, emptyValue: []});
            },
            getCount: function () {
                httpGet.call(this, $routes.alerts.getCount(),
                    {emptyValue: 0});
            },
            details: function (alertId, responseConverter) {
                httpGet.call(this,
                    $routes.alerts.details(alertId),
                    {responseConverter: responseConverter, emptyValue: []});
            }
        },
        payments: {
            getPayees: function (responseConverter) {
                httpGet.call(this, $routes.payments.getPayees,
                    {responseConverter: responseConverter, emptyValue: []});
            },
            getText: function (responseConverter) {
                httpGet.call(this, $routes.payments.getText,
                    {responseConverter: responseConverter, emptyValue: []});
            }
        },
        communications: {
            getSettings: function (responseConverter) {
                httpGet.call(this, $routes.communications.getSettings,
                    {responseConverter: responseConverter});
            },
            getMobileNumbers: function (responseConverter) {
                httpGet.call(this,
                    $routes.communications.getMobileNumbers,
                    {responseConverter: responseConverter, emptyValue: []});
            },
            getEmail: function () {
                httpGet.call(this,
                    $routes.communications.getEmail, {emptyValue: ''});
            },
            getConfiguration: function (responseConverter) {
                httpGet.call(this,
                    $routes.communications.getConfiguration, {responseConverter: responseConverter});
            },
            getCampaignDetails: function (responseConverter) {
                httpGet.call(this,
                    $routes.communications.getCampignDetails, { responseConverter: responseConverter });
            }
        },
        accounts: {
            list: function (responseConverter) {
                httpGet.call(this, $routes.accounts.list,
                    {responseConverter: responseConverter, emptyValue: []});
            },
            listReassociated: function (responseConverter) {
                httpGet.call(this, $routes.accounts.listReassociated,
                    {responseConverter: responseConverter, emptyValue: []});
            },
            single: function (accountId) {
                httpGet.call(this, $routes.accounts.single(accountId));
            },
            detailsHsa: function (accountId) {
                httpGet.call(this, $routes.accounts.detailsHsa(accountId));
            },
            detailsNonHsa: function (accountId, options) {
                httpGet.call(this,
                    $routes.accounts.detailsNonHsa({id: accountId, options: options}));
            },
            dependentsNonHsa: function (accountId, options) {
                httpGet.call(this,
                    $routes.accounts.dependentsNonHsa({id: accountId, options: options}));
            },
            claimsAutoPaymentPref: function (accountId, options) {
                httpGet.call(this, $routes.accounts.claimsAutoPaymentPref({
                    id: accountId,
                    options: options
                }), {emptyValue: null});
            },
            RequiredCipDocumentation: function (flexAccId, responseConverter) {
                httpGet.call(this, $routes.accounts.RequiredCipDocumentation({flexAccId: flexAccId}), {
                    responseConverter: responseConverter,
                    emptyValue: false
                });
            },
            getCurrentHsaPaper: function (responseConverter) {
                httpGet.call(this,
                    $routes.accounts.getCurrentHsaPaper({
                        responseConverter: responseConverter
                    }));
            },
            getThreshold: function (responseConverter) {
                httpGet.call(this,
                    $routes.accounts.getThreshold({
                        responseConverter: responseConverter
                    }));
            },
            fsaStore: function (responseConverter) {
                httpGet.call(this,
                    $routes.accounts.fsaStore({
                        responseConverter: responseConverter
                    }));
            },
            intervalTracker: function (accountId, planYear) {
                httpGet.call(this, $routes.accounts.intervalTracker(accountId, planYear));
            },
            stableProvider: function (flexacctId) {
                httpGet.call(this, $routes.accounts.stableProvider(flexacctId));
            },
            disclosures: function (flexacctId) {
                httpGet.call(this, $routes.accounts.disclosures(flexacctId));
            }
        },
        accountActivity: {
            getPage: function () {
                httpGet.call(this, $routes.accountActivity.getPage());
            },
            getRecent: function () {
                httpGet.call(this, $routes.accountActivity.getRecent());
            },
            getYears: function () {
                httpGet.call(this, $routes.accountActivity.getYears());
            },
            getBalanceDue: function () {
                httpGet.call(this, $routes.accountActivity.getBalanceDue())
            }
        },
        claims: {
            get: function (responseConverter) {
                httpGet.call(this, $routes.claims.get,
                    {responseConverter: responseConverter, emptyValue: []});
            },
            getPage: function (args, responseConverter) {
                httpGet.call(this,
                    $routes.claims.getPage(args),
                    {responseConverter: responseConverter, emptyValue: []});
            },
            getRequiredAttentionItems: function (responseConverter) {
                httpGet.call(this, $routes.claims.getRequiredAttentionItems,
                    {responseConverter: responseConverter, emptyValue: []});
            },
            medicalDetails: function () {
                httpPost.call(this, $routes.claims.medicalDetails, {dataType: 'json'});
            },
            fxDetails: function () {
                httpPost.call(this, $routes.claims.fxDetails, {dataType: 'json'});
            },
            entryTemplate: function (responseConverter) {
                httpGet.call(this, $routes.claims.entryTemplate,
                    {responseConverter: responseConverter, emptyValue: null});
            },
            submitClaimWidgetData: function (args, responseConverter) {
                httpPost.call(this, $routes.claims.submitClaimWidgetData,
                    {responseConverter: responseConverter, emptyValue: null, dataType: 'json'})
            },
            downloadFaxCover: function (args, responseConverter) {
                httpGet.call(this,
                    $routes.claims.downloadFaxCover, {responseConverter: responseConverter, emptyValue: null})
            }
        },
        cards: {
            list: function (responseConverter) {
                httpGet.call(this, $routes.cards.list,
                    {responseConverter: responseConverter, emptyValue: []});
            },

            dependents: function (responseConverter) {
                httpGet.call(this, $routes.cards.dependents,
                    {responseConverter: responseConverter, emptyValue: []});
            },

            details: function (cardProxyNumber) {
                httpGet.call(this, $routes.cards.details(cardProxyNumber));
            },
            pin: function (cardProxyNumber) {
                httpGet.call(this, $routes.cards.pin(cardProxyNumber));
            }
        },
        expenses: {
            getSummary: function () {
                httpGet.call(this, $routes.expenses.getSummary, {emptyValue: []});
            },
            getEligibleExpenseList: function (planId, planStartDate, planEndDate) {
                httpGet.call(this, $routes.expenses.getEligibleExpenseList({
                    planId: planId,
                    planStartDate: planStartDate,
                    planEndDate: planEndDate
                }))
            },
            getEligibleAccounts: function (responseConverter) {
                httpGet.call(this, $routes.expenses.getEligibleAccounts, {
                    responseConverter: responseConverter,
                    emptyValue: []
                })
            }
        },
        documentqueue: {
            list: function () {
                httpGet.call(this, $routes.documentqueue.list, {emptyValue: []});
            }
        },
        investments: {
            getForAccount: function (accountId) {
                httpGet.call(this, $routes.investments.getForAccount(accountId));
            },
            getTransferInfo: function () {
                httpGet.call(this, $routes.investments.getTransferInfo());
            },
            getInvestmentsStatus: function (accountId) {
                httpGet.call(this, $routes.investments.getInvestmentsStatus(accountId));
            },
            getInvestmentPartnerSsoUrl: function (accountId) {
                httpGet.call(this, $routes.investments.getInvestmentPartnerSsoUrl(accountId));
            },
            getPendingTransfers: function (accountId) {
                httpGet.call(this, $routes.investments.getPendingTranfers(accountId), {emptyValue: []});
            },
            getInvestmentsCustomText: function () {
                httpGet.call(this, $routes.investments.getInvestmentsCustomText());
            },
            getTrustPlanData: function () {
                httpGet.call(this, $routes.investments.getTrustPlanData());
            },
            getDevenirSid: function (accountId) {
                httpGet.call(this, $routes.investments.getDevenirSid(accountId));
            },
            getDevenirPendingElection: function (accountId) {
                httpGet.call(this, $routes.investments.getDevenirPendingElection(accountId));
            },
            getDevenirPendingRealignment: function (accountId) {
                httpGet.call(this, $routes.investments.getDevenirPendingRealignment(accountId));
            },
            getDevenirCancelRealignmentPending: function (accountId) {
                httpGet.call(this, $routes.investments.getDevenirCancelRealignmentPending(accountId));
            },
            getDevenirRealignmentOptions: function (accountId) {
                httpGet.call(this, $routes.investments.getDevenirRealignmentOptions(accountId));
            },
            getDevenirRealignmentCurrent: function (accountId) {
                httpGet.call(this, $routes.investments.getDevenirRealignmentCurrent(accountId));
            }
        },
        cms: {
            menuItemList: function () {
                httpGet.call(this, $routes.cms.getMenuItemList, {emptyValue: []});
            },
            pageUrlList: function (responseConverter) {
                httpGet.call(this, $routes.cms.getPageUrlList, {responseConverter: responseConverter, emptyValue: []});
            },
            footerModel: function () {
                httpGet.call(this, $routes.cms.footer.get());
            },
            footerList: function () {
                httpGet.call(this, $routes.cms.footer.list());
            },
            tenantList: function (responseConverter) {
                httpGet.call(this, $routes.cms.tenant.list(), {responseConverter: responseConverter});
            },
            employees: {
                list: function () {
                    httpPost.call(this, $routes.cms.employees.list());
                }
            },
            partners: {
                list: function () {
                    httpGet().call(this, $routes.cms.partners.list());
                }
            },
            employers: {
                list: function (responseConverter) {
                    httpGet.call(this, $routes.cms.employers.list, {responseConverter: responseConverter});
                },
                all: function (responseConverter, tpaIds) {
                    tpaIds = tpaIds || [];
                    let url = $routes.cms.employers.all;
                    if (tpaIds.length > 0) {
                        const query = tpaIds.map(function (tpaId) {
                            return "tpaIds=" + tpaId;
                        }).join("&");
                        url += "?" + query;
                    }
                    httpGet.call(this, url, {responseConverter: responseConverter});
                }
            },
            announcements: function (responseConverter) {
                httpGet.call(this,
                    $routes.cms.announcements(),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            announcementDetails: function (announcementKey, responseConverter) {
                httpGet.call(this,
                    $routes.cms.announcementDetails(announcementKey),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            faqs: function (responseConverter) {
                httpGet.call(this,
                    $routes.cms.faqs(),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            faqDetails: function (announcementKey, responseConverter) {
                httpGet.call(this,
                    $routes.cms.faqDetails(announcementKey),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            documents: function (responseConverter) {
                httpGet.call(this,
                    $routes.cms.documents(),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            documentCategories: function (responseConverter) {
                httpGet.call(this,
                    $routes.cms.documentCategories(),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            documentAudiences: function (responseConverter) {
                httpGet.call(this,
                    $routes.cms.documentAudiences(),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            documentDetails: function (key, responseConverter) {
                httpGet.call(this,
                    $routes.cms.documentDetails(key),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            publicDocuments: function (key, responseConverter) {
                httpGet.call(this,
                    $routes.cms.publicDocuments.get(key),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            publicDocumentDetails: function (key, responseConverter) {
                httpGet.call(this,
                    $routes.cms.publicDocuments.details(key),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            apiVersion: function () {
                httpGet.call(this, $routes.cms.apiVersion());
            },

            importHistoryDetails: function () {
                httpGet.call(this,
                    $routes.cms.importHistory());
            },
            eConsentBanks: {
                list: function (responseConverter) {
                    httpGet.call(this,
                        $routes.cms.eConsentBanks.list, {responseConverter: responseConverter})
                },
                getBank: function (bankId, responseConverter) {
                    httpGet.call(this, $routes.cms.eConsentBanks.getBank + '/' + bankId,
                        {responseConverter: responseConverter, emptyValue: '[]'})
                }
            },
            customLabels: {
                get: function (responseConverter) {
                    httpGet.call(this,
                        $routes.cms.customLabels.get, {responseConverter: responseConverter});
                }
            }
        },
        partners: {
            tpaStreamStatus: function (responseConverter) {
                httpGet.call(this, $routes.partners.tpaStreamStatus,
                    {responseConverter: responseConverter});
            }
            },
        profile: {
            get: function (responseConverter) {
                httpGet.call(this, $routes.profile.get,
                    {responseConverter: responseConverter});
            },
            getPicture: function (responseConverter) {
                httpGet.call(this, $routes.profile.getPicture,
                    {responseConverter: responseConverter});
            },
            dependents: function (responseConverter, age) {
                httpGet.call(this, $routes.profile.dependents(age),
                    {responseConverter: responseConverter, emptyValue: []});
            },
            dependentDetails: function (dependentId, unmask) {
                httpGet.call(this, $routes.profile.dependentDetails({id: dependentId, unmask: unmask || false}));
            },
            dependentFreeId: function () {
                httpGet.call(this, $routes.profile.getDependentFreeId());
            },
            eConsentStatus: function () {
                httpGet.call(this, $routes.profile.eConsentStatus)
            },
            getEConsentBanks: function (responseConverter) {
                httpGet.call(this, $routes.profile.getEConsentBanks,
                    {responseConverter: responseConverter})
            },
            getBank: function (responseConverter) {
                httpGet.call(this, $routes.profile.getBank,
                    {responseConverter: responseConverter})
            },
            employeeData: function (respnoseConverter) {
                httpGet.call(this, $routes.profile.employeeData,
                    {responseConverter: respnoseConverter})
            }
        },
        authentication: {
            getTicketForDirectDeposit: function () {
                httpPost.call(this, $routes.authentication.getTicketForDirectDeposit());
            },
            logoutIdle: function () {
                httpPost.call(this, $routes.authentication.logoutIdle());
            }
        },
        scontent: {
            states: function (responseConverter) {
                httpGet.call(this, $routes.static.states,
                    {responseConverter: responseConverter, cache: true});
            },
            countries: function (responseConverter) {
                httpGet.call(this, $routes.static.countries,
                    {responseConverter: responseConverter, cache: true});
            },
            enrollmentsCountries: function (responseConverter) {
                httpGet.call(this, $routes.static.enrollmentsCountries,
                    {responseConverter: responseConverter, cache: true});
            }
        },
        registration: {
            questions: function (responseConverter) {
                httpGet.call(this, $routes.registration.questions(),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            userInfo: function (responseConverter) {
                httpGet.call(this, $routes.registration.userInfo(),
                    {responseConverter: responseConverter});
            },
            employeeIdNotes: function (responseConverter) {
                httpGet.call(this, $routes.registration.employeeIdNotes(),
                    {responseConverter: responseConverter});
            },
            employerList: function (responseConverter) {
                httpGet.call(this, $routes.registration.employerList(),
                    {responseConverter: responseConverter})
            },
            registrationWidgetData: function () {
                httpGet.call(this, $routes.registration.registrationWidgetData())
            },
            termsOfUse: function () {
                httpGet.call(this, $routes.registration.termsOfUse())
            }
        },
        smartRegistration: {
            getContextData: function () {
                httpGet.call(this, $routes.smartRegistration.getContextData())
            }
        },
        receipts: {
            images: {
                model: function (id) {
                    httpGet.call(this, $routes.receipts.image.getModel(id));
                }
            }
        },
        resources: {
            documents: function () {
                httpGet.call(this, $routes.resources.documents());
            },
            downloadDocument: function (fileKey) {
                httpGet.call(this, $routes.resources.downloadDocument(fileKey));
            },
            announcements: function (responseConverter) {
                httpGet.call(this,
                    $routes.resources.announcements(),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            faq: function (responseConverter) {
                httpGet.call(this,
                    $routes.resources.faq(),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            },
            publicDocuments: function (responseConverter) {
                httpGet.call(this,
                    $routes.resources.publicDocuments(),
                    {responseConverter: responseConverter, emptyValue: '[]'});
            }
        },
        statements: {
            list: function (accountId) {
                httpGet.call(this, $routes.statements.list(accountId));
            },
            listReassociated: function (accountId) {
                httpGet.call(this, $routes.statements.listReassociated(accountId));
            },
            getDeliveryOption: function (accountId) {
                httpGet.call(this, $routes.statements.deliveryOption(accountId));
            },
            pdfpin: function (accountId) {
                httpGet.call(this, $routes.taxforms.pdfpin(accountId));
            }
        },
        taxforms: {
            list: function (accountId) {
                httpGet.call(this, $routes.taxforms.list(accountId));
            },
            listReassociated: function (accountId) {
                httpGet.call(this, $routes.taxforms.listReassociated(accountId));
            },
            getDeliveryOption: function (accountId) {
                httpGet.call(this, $routes.taxforms.deliveryOption(accountId));
            },
            pdfpin: function (accountId) {
                httpGet.call(this, $routes.taxforms.pdfpin(accountId));
            }
        },
        enrollments: {
            get: function (responseConverter) {
                httpGet.call(this, $routes.enrollments.get(), {responseConverter: responseConverter, emptyValue: []});
            },
            getWithHsaTemplate: function (params, responseConverter) {
                httpGet.call(this, $routes.enrollments.getWithHsaTemplate(params), {
                    responseConverter: responseConverter,
                    emptyValue: []
                });
            },
            details: function (responseConverter) {
                httpGet.call(this, $routes.enrollments.details(), {
                    responseConverter: responseConverter,
                    emptyValue: null
                });
            },
            waive: function (responseConverter) {
                httpGet.call(this, $routes.enrollments.waive(), {
                    responseConverter: responseConverter,
                    emptyValue: null
                });
            },
            beneficiaries: function (responseConverter) {
                httpGet.call(this, $routes.enrollments.getBeneficiaries(), {
                    responseConverter: responseConverter,
                    emptyValue: []
                });
            },
            beneficiary: function (responseConverter) {
                httpGet.call(this, $routes.enrollments.getBeneficiary(), {
                    responseConverter: responseConverter,
                    emptyValue: []
                });
            },
            flexAccount: function (responseConverter) {
                httpGet.call(this, $routes.enrollments.getFlexAccount(), {
                    responseConverter: responseConverter,
                    emptyValue: null
                });
            },
            checkAnonymous: function (responseConverter) {
                httpGet.call(this, $routes.enrollments.checkAnonymous(), {
                    responseConverter: responseConverter,
                    emptyValue: null
                });
            }
        },
        reimbursements: {
            list: function (responseConverter) {
                httpGet.call(this, $routes.reimbursements.list(), {
                    responseConverter: responseConverter,
                    emptyValue: []
                });
            }
        },
        repayment: {
            balanceAlert: function (responseConverter) {
                httpGet.call(this, $routes.repayment.balanceAlert(), {
                    responseConverter: responseConverter,
                    emtyValue: null
                })
            },
            details: function (responseConverter) {
                httpGet.call(this, $routes.repayment.details(), {
                    responseConverter: responseConverter,
                    emtyValue: null
                })
            },
            getRepayedTransactions: function (responseConverter) {
                httpGet.call(this, $routes.repayment.getRepayedTransactions(), {
                    responseConverter: responseConverter,
                    emtyValue: null
                })
            },
            authorizationCustomText: function (responseConverter) {
                httpGet.call(this, $routes.repayment.authorizationCustomText(), {
                    responseConverter: responseConverter,
                    emtyValue: null
                })
            }
        },
        user: {
            getInfo: function () {
                httpGet.call(this, $routes.user.getInfo());
            }
        },
        findcare: {
            getInsurances: function () {
                httpGet.call(this, $routes.findCare.getInsurances());
            }
        },
        merchantLocator: {
            getStoreLocations: function () {
                httpGet.call(this, $routes.merchantLocator.getStoreLocations());
            }
        }
        
    };

    var postRequests = {
        alerts: {
            markAsViewed: function (alertId) {
                httpPost.call(this,
                    $routes.alerts.markAsViewed(alertId));
            },
            delete: function (alertId) {
                httpPost.call(this,
                    $routes.alerts.delete(alertId));
            }
        },
        bankAccounts: {
            add: function () {
                httpPost.call(this, $routes.bankAccounts.add);
            },
            delete: function (bankAccountId) {
                httpPost.call(this,
                    $routes.bankAccounts.delete(bankAccountId));
            },
            edit: function (bankAccountId) {
                httpPost.call(this,
                    $routes.bankAccounts.edit(bankAccountId));
            },
            validate: function () {
                httpPost.call(this,
                    $routes.bankAccounts.validate());
            }
        },
        communications: {
            editSettings: function () {
                httpPost.call(this, $routes.communications.editSettings);
            },
            registerMobileNumber: function () {
                httpPost.call(this, $routes.communications.registerMobileNumber);
            },
            unregisterMobileNumber: function () {
                httpPost.call(this, $routes.communications.unregisterMobileNumber);
            },
            deleteMobileNumber: function () {
                httpPost.call(this, $routes.communications.deleteMobileNumber);
            },
            contactAdmin: function () {
                httpPost.call(this, $routes.communications.contactAdmin);
            }
        },
        contributions: {
            add: function () {
                httpPost.call(this, $routes.contributions.add);
            },
            edit: function (contributionId) {
                httpPost.call(this,
                    $routes.contributions.edit(contributionId));
            },
            delete: function (contributionId) {
                httpPost.call(this,
                    $routes.contributions.delete(contributionId));
            }
        },
        payments: {
            add: function () {
                httpPost.call(this, $routes.payments.add);
            },
            addProvider: function () {
                httpPost.call(this, $routes.payments.addProvider);
            },
            deleteProvider: function () {
                httpPost.call(this, $routes.payments.deleteProvider);
            }
        },
        documentqueue: {
            upload: function () {
                httpPost.call(this, $routes.documentqueue.upload);
            }
        },
        investments: {
            transfer: function () {
                httpPost.call(this, $routes.investments.transfer);
            },
            applyForAccount: function () {
                httpPost.call(this, $routes.investments.applyForAccount);
            },
            updateAutoTransfer: function (accountId, transferAmountsAbove, minAutoTransferAmount, resetAutoTransfer) {
                httpPost.call(this, $routes.investments.updateAutoTransfer({
                    id: accountId,
                    transferAmountsAbove: transferAmountsAbove,
                    minAutoTransferAmount: minAutoTransferAmount,
                    resetAutoTransfer: resetAutoTransfer
                }));
            },
            updateDevenirAllocation: function () {
                httpPost.call(this, $routes.investments.updateDevenirAllocation);
            }
        },
        transactions: {
            setMarkAsIneligible: function () {
                httpPost.call(this, $routes.transactions.setMarkAsIneligible);
            }
        },
        receipts: {
            image: {
                addToTransaction: function () {
                    httpPost.call(this, $routes.receipts.image.addToTransaction);
                },
                addToExpense: function () {
                    httpPost.call(this, $routes.receipts.image.addToExpense);
                },
                addToClaim: function () {
                    httpPost.call(this, $routes.receipts.image.addToClaim);
                }
            }
        },
        cards: {
            lost: function () {
                httpPost.call(this, $routes.cards.lost);
            },
            activate: function () {
                httpPost.call(this, $routes.cards.activate);
            },
            new: function () {
                httpPost.call(this, $routes.cards.new);
            }
        },
        profile: {
            update: function () {
                httpPost.call(this, $routes.profile.update);
            },
            updateEmail: function () {
                httpPost.call(this, $routes.profile.updateEmail);
            },
            updateLanguage: function () {
                httpPost.call(this, $routes.profile.updateLanguage);
            },
            updateDependent: function () {
                httpPost.call(this, $routes.profile.updateDependent);
            },
            addDependent: function () {
                httpPost.call(this, $routes.profile.addDependent);
            },
            deleteDependent: function () {
                httpPost.call(this, $routes.profile.deleteDependent);
            },
            updateReimbursementMethodInfo: function () {
                httpPost.call(this, $routes.profile.updateReimbursementMethod);
            },
            updateUserPicture: function () {
                httpPost.call(this, $routes.profile.updateUserPicture());
            },
            validateBankAccount: function () {
                httpPost.call(this, $routes.profile.validateBankAccount);
            },
            submitEConsent: function () {
                httpPost.call(this, $routes.profile.submitEConsent);
            },
            checkDuplicateSsn: function () {
                httpPost.call(this, $routes.profile.checkDuplicateSsn)
            },
            deleteAccountCredentials: function () {
                httpDelete.call(this, $routes.profile.deleteAccountCredentials);
            }
        },
        authentication: {
            generateCode: function () {
                httpPost.call(this, $routes.authentication.generateCode);
            },
            submitCode: function () {
                httpPost.call(this, $routes.authentication.submitCode);
            },
            userInfo: function () {
                httpPost.call(this, $routes.authentication.userInfo);
            },
            refreshTicketForLogin: function () {
                httpPost.call(this, $routes.authentication.refreshTicketForLogin);
            },
            logOff: function () {
                httpPost.call(this, $routes.authentication.logOff);
            },
            unlockAccount: function () {
                httpPost.call(this, $routes.authentication.unlockAccount);
            },
            changeLanguage: function () {
                httpPost.call(this, $routes.authentication.changeLanguage)
            }
        },
        accounts: {
            claimsAutoPaymentPref: function () {
                httpPost.call(this, $routes.accounts.claimsAutoPaymentPref);
            },
            updateAccountDeductibleStatus: function (accountId, options, isStatusMet) {
                httpPost.call(this, $routes.accounts.updateAccountDeductibleStatus({
                    id: accountId,
                    options: options,
                    isStatusMet: isStatusMet
                }));
            },
            updateHighYieldStatus: function (accountId, highYieldOptIn) {
                httpPost.call(this, $routes.accounts.updateHighYieldStatus({
                    id: accountId,
                    options: this.options,
                    highYieldOptIn: highYieldOptIn
                }));
            }
        },
        claims: {
            add: function () {
                httpPost.call(this, $routes.claims.add);
            },
            fxClaimMarkAsPaid: function () {
                httpPost.call(this, $routes.claims.fxClaimMarkAsPaid)
            },
            MultipleFxClaimMarkAsPaid: function () {
                httpPost.call(this, $routes.claims.MultipleFxClaimMarkAsPaid, {contentType: "application/json" })
            },
            update: function () {
                httpPost.call(this, $routes.claims.update);
            },
            submitClaimWidgetData: function () {
                httpPost.call(this, $routes.claims.submitClaimWidgetData)
            }
        },
        cms: {
            resetMenuItemList: function () {
                httpPost.call(this, $routes.cms.resetMenuItemList);
            },
            editMenuItemList: function () {
                httpPost.call(this, $routes.cms.editMenuItemList);
            },
            resetBrandData: function () {
                httpPost.call(this, $routes.cms.brandData.reset);
            },
            createBrandData: function () {
                httpPost.call(this, $routes.cms.brandData.create);
            },
            deleteBrandData: function () {
                httpPost.call(this, $routes.cms.brandData.delete);
            },
            editFooterData: function () {
                httpPost.call(this, $routes.cms.footer.edit);
            },
            resetFooterData: function () {
                httpPost.call(this, $routes.cms.footer.reset);
            },
            employees: {
                search: function () {
                    httpPost.call(this, $routes.cms.employees.search);
                }
            },
            saveUpdateAnnouncement: function () {
                httpPost.call(this, $routes.cms.saveUpdateAnnouncement);
            },
            deleteAnnouncement: function (key) {
                httpPost.call(this, $routes.cms.deleteAnnouncement(key));
            },
            saveUpdateFAQ: function () {
                httpPost.call(this, $routes.cms.saveUpdateFAQ);
            },
            deleteFAQ: function (key) {
                httpDelete.call(this, $routes.cms.deleteFAQ + '/' + key);
            },
            saveDocument: function () {
                httpPost.call(this, $routes.cms.saveDocument);
            },
            deleteDocument: function (key) {
                httpPost.call(this, $routes.cms.deleteDocument(key));
            },
            createTenant: function () {
                httpPost.call(this, $routes.cms.tenant.create);
            },
            deleteTenant: function () {
                httpPost.call(this, $routes.cms.tenant.delete);
            },
            importTenant: function () {
                httpPost.call(this, $routes.cms.tenant.import(), {processData: false});
            },
            importMultilingualTenant: function () {
                httpPost.call(this, $routes.cms.tenant.importMultilingual(), { processData: false });
            },
            restoreTenant: function () {
                httpPost.call(this, $routes.cms.tenant.restore);
            },
            deletePublicDocument: function (key) {
                httpDelete.call(this, $routes.cms.publicDocuments.delete(key));
            },
            savePublicDocument: function () {
                httpPost.call(this, $routes.cms.publicDocuments.save);
            },
            getPublicDocumentCategories: function () {
                httpGet.call(this, $routes.cms.publicDocuments.categories);
            },
            eConsentBanks: {
                addBank: function () {
                    httpPost.call(this, $routes.cms.eConsentBanks.add)
                },
                editBank: function () {
                    httpPut.call(this, $routes.cms.eConsentBanks.edit)
                },
                deleteBank: function (bankId) {
                    httpDelete.call(this, $routes.cms.eConsentBanks.delete + '/' + bankId)
                }
            },
            customLabels: {
                save: function () {
                    httpPost.call(this, $routes.cms.customLabels.save);
                }
            }
        },
        expenses: {
            details: function () {
                httpPost.call(this, $routes.expenses.details, {emptyValue: null});
            },
            add: function () {
                httpPost.call(this, $routes.expenses.add);
            },
            delete: function () {
                httpPost.call(this, $routes.expenses.delete);
            },
            groupDelete: function () {
                httpPost.call(this, $routes.expenses.groupDelete);
            },
            editManual: function () {
                httpPost.call(this, $routes.expenses.editManual);
            },
            editTps: function () {
                httpPost.call(this, $routes.expenses.editTps);
            },
            submitExpenseWidgetData: function () {
                httpPost.call(this, $routes.expenses.submitExpenseWidgetData)
            }
        },
        registration: {
            create: function () {
                httpPost.call(this, $routes.registration.create);
            },
            enroll: function () {
                httpPost.call(this, $routes.registration.enroll);
            }
        },
        smartRegistration: {
            searchEmployee: function () {
                httpPost.call(this, $routes.smartRegistration.searchEmployee);
            },
            addEmployeeDetails: function () {
                httpPost.call(this, $routes.smartRegistration.addEmployeeDetails);
            },
            addDebitCard: function () {
                httpPost.call(this, $routes.smartRegistration.addDebitCard);
            },
            sendCode: function () {
                httpPost.call(this, $routes.smartRegistration.sendCode);
            },
            validateCode: function () {
                httpPost.call(this, $routes.smartRegistration.validateCode);
            },
            createUser: function () {
                httpPost.call(this, $routes.smartRegistration.createUser);
            },
            tryToLogin: function () {
                httpPost.call(this, $routes.smartRegistration.tryToLogin);
            }
        },
        statements: {
            setDeliveryOption: function () {
                httpPost.call(this, $routes.statements.deliveryOption);
            }
        },
        taxforms: {
            setDeliveryOption: function () {
                httpPost.call(this, $routes.taxforms.deliveryOption);
            }
        },
        enrollments: {
            submitWaive: function () {
                httpPost.call(this, $routes.enrollments.submitWaive);
            },
            submitFlexAccount: function () {
                httpPost.call(this, $routes.enrollments.submitFlexAccount);
            },
            saveDemographic: function () {
                httpPost.call(this, $routes.enrollments.saveDemographic);
            },
            saveBeneficiary: function () {
                httpPost.call(this, $routes.enrollments.saveBeneficiary);
            },
            deleteBeneficiary: function () {
                httpPost.call(this, $routes.enrollments.deleteBeneficiary);
            },
            updateBeneficiariesPercentage: function () {
                httpPost.call(this, $routes.enrollments.updateBeneficiariesPercentage);
            },
            anonymous: function () {
                httpPost.call(this, $routes.enrollments.anonymous);
            },
            cancel: function () {
                httpPost.call(this, $routes.enrollments.cancel);
            }
        },
        hsaDisclosure: {
            getByRequest: function () {
                httpPost.call(this, $routes.hsaDisclosure.getByRequest);
            },
            getByToken: function () {
                httpPost.call(this, $routes.hsaDisclosure.getByToken);
            },
            acknowledge: function () {
                httpPost.call(this, $routes.hsaDisclosure.acknowledge);
            },
            pdfPin: function () {
                httpPost.call(this, $routes.hsaDisclosure.pdfPin);
            }
        },
        repayment: {
            submit: function () {
                httpPost.call(this, $routes.repayment.submit);
            },
            repay: function () {
                httpPost.call(this, $routes.repayment.repay);
            }
        },
        partners: {
            getConnectAccessToken: function () {
                httpPost.call(this, $routes.partners.getConnectAccessToken);
            }
        },
        productSearchILA:{
            getProducts: function() {
                httpPost.call(this, $routes.ProductsSearch);
            }
        }
    };

    $.extend(true, $, {
        cdh: {
            get: getRequests,
            post: postRequests
        }
    });
})(jQuery);